import * as React from "react"
// @ts-ignore
import styles from "./MobileNav.module.scss"
// @ts-ignore
import burgerMenuMobile from '../../../../assets/burger-menu-mobile.svg'
// @ts-ignore
import chevronDown from '../../../../assets/chevron-down.svg'

import { menuItems } from '../../../header/Navigation'

import ContactCard from "../ContactCard"


const MobileNav = ({LinkComponent}) => {
  const [showMenu, setShowMenu] = React.useState(false)
  const [subMenuIndex, setSubMenuIndex] = React.useState({})

  const handleMenuToggleClick = () => {
    setShowMenu(!showMenu)
  }

  const handleSubMenuToggleClick = index => {
    const selected = { ...subMenuIndex }
    selected[index] = !selected[index]
    setSubMenuIndex(selected)
  }

  return (
    <div className={styles.MobileNav}>
      <div
        className={styles.hamburgerMobileContainer}
        onClick={handleMenuToggleClick}
      >
        <img src={burgerMenuMobile} alt='menu icon' />
      </div>

      <div className={showMenu ? styles.overlay : styles.overlayHidden}>
        <div className={styles.closeContainer}>
          <p>Close</p>
          <a
            href="#"
            className={styles.closebtn}
            onClick={handleMenuToggleClick}
          >
            &times;
          </a>
        </div>

        {menuItems.map((item, index) => {
          const isClicked = subMenuIndex[index]
          return (
            <div className={styles.contentContainer} key={index}>
              <LinkComponent className={styles.menuItem} to={item.path}>
                {item.title}
              </LinkComponent>
              {item.subMenu && (
                <div
                  className={styles.dropdown}
                  onClick={() => handleSubMenuToggleClick(index)}
                >
                  {isClicked ? (
                    <img src={chevronDown} alt='chevron down icon' className={styles.chevronDown} />
                  ) : (
                    <img src={chevronDown} alt='chevron right icon' className={styles.chevronRight} />
                  )}
                </div>
              )}
              {item.subMenu &&
                isClicked &&
                item.subMenu.map((subMenuItem, index) => (
                  <div className={styles.subMenuItem} key={index}>
                    <LinkComponent className={styles.subMenuLink} to={subMenuItem.path}>
                      {subMenuItem.title}
                    </LinkComponent>
                  </div>
                ))}
            </div>
          )
        })}

        <ContactCard mobileNav={true} />
      </div>
    </div>
  )
}

export default MobileNav
